module.exports = __webpack_public_path__ + "img/faded76c-4da1-49bb-98dc-10b8276f7da8.b8d2724b.webp";